<template>
    <div class="career-advantages">
        <z-caption tag="h2" size="lt">{{ title }}</z-caption>
        <div class="career-advantages__slider swiper-container swiper js-career-advantages-slider">
            <div class="swiper-wrapper">
                <div
                    v-for="(item, index) in detail.adventages"
                    :key="index"
                    class="career-advantages__slide swiper-slide u-flex u-gap--xl"
                >
                    <z-card
                        :contentData="{ title: item.name }"
                        :is-background-image="false"
                        :image="item.link"
                        theme="clipped-secondary"
                    >
                    </z-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import Swiper from 'swiper'

const props = defineProps({
    detail: {
        type: Object
    },
    title: {
        type: String,
        default: 'Преимущества'
    },
})
let careerAdvantagesSlider;
const careerAdvantagesSwiper = ref();

const getSpaceBetween = () => {
    return window.innerWidth < 1024 ? 20 : 54;
};

const getSlidesPerView = () => {
    if (window.innerWidth < 1024 && window.innerWidth > 600) return 2.2
    if (window.innerWidth <= 600) return 1.2
    return 3.2;
};
onMounted(() => {
    careerAdvantagesSlider = document.querySelector('.js-career-advantages-slider')
    careerAdvantagesSwiper.value = new Swiper(careerAdvantagesSlider, {
        slidesPerView: getSlidesPerView(),
        spaceBetween: getSpaceBetween(),
        speed: 400,
        freeMode: true,
        pagination: {
            clickable: true
        },
    })

})

window.addEventListener('resize', () => {
    if (careerAdvantagesSwiper.value) {
        careerAdvantagesSwiper.value.params.spaceBetween = getSpaceBetween();
        careerAdvantagesSwiper.value.params.slidesPerView = getSlidesPerView();
        careerAdvantagesSwiper.value.update();
    }
});

</script>

<style lang="scss">
.career-advantages {
    padding: var(--spacer-s) 0;
    width: 100%;
    height: 100%;

    .z-card--theme-clipped-secondary {
        max-width: fit-content;
    }

    &__slider {
        padding: 40px;
        margin-left: -40px;
        overflow: visible;
    }

    &__slide {
        height: auto;
    }

    .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .z-card {
        aspect-ratio: auto;
    }

    .z-card--theme-clipped-secondary:hover .z-card__content,
    .z-card--theme-clipped-secondary:hover .z-card__content-hidden {
        transform: none;
    }

    .z-button--kind-primary,
    .z-card__content-hidden {
        display: none;
    }

    .z-caption {
        margin-bottom: 0;
    }
}
</style>
